import React from 'react'

function Star({className}) {
    return <svg className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.3895 1.14875L10.7995 3.96875C10.9895 4.35875 11.4995 4.72875 11.9295 4.80875L14.4795 5.22875C16.1095 5.49875 16.4895 6.6788 15.3195 7.8588L13.3295 9.8488C12.9995 10.1788 12.8095 10.8288 12.9195 11.2988L13.4895 13.7588C13.9395 15.6988 12.8995 16.4588 11.1895 15.4388L8.7995 14.0188C8.3695 13.7588 7.6495 13.7588 7.2195 14.0188L4.8295 15.4388C3.11945 16.4488 2.07945 15.6988 2.52945 13.7588L3.09945 11.2988C3.18945 10.8188 2.99945 10.1688 2.66945 9.8388L0.679454 7.8488C-0.490546 6.6788 -0.110546 5.49875 1.51945 5.21875L4.0695 4.79875C4.4995 4.72875 5.0095 4.34875 5.1995 3.95875L6.6095 1.13875C7.3795 -0.381247 8.6195 -0.381247 9.3895 1.14875Z"/>
    </svg>
    
}

export default Star
